import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    static targets = ["modal", "tokenField"]
    static values = { url: String }
    initialize() {
    }

    connect() {
        this.modal = Modal.getOrCreateInstance(this.modalTarget)
    }

    async getToken(event) {
        event.preventDefault()

        try {
            const response = await fetch(this.urlValue, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json'
                }
            })

            const { token } = await response.json()
            this.tokenFieldTarget.value = token
            this.modal.show()
        } catch (error) {
            console.error('Error:', error)
        }
    }

    closeModal() {
        this.modal.hide()
    }

    copyToClipboard() {
        this.tokenFieldTarget.select()
        navigator.clipboard.writeText(this.tokenFieldTarget.value)
            .then(() => toastr.success("Токен скопирован в буфер обмена"))
            .catch(() => toastr.error("Не удалось скопировать токен"))
    }

    shareToken() {
        const url = `https://kibet.rocket.tatar/service/auth?token=${this.tokenFieldTarget.value}`

        if (navigator.share) {
            navigator.share({ url })
                .catch((error) => { if (error.name !== 'AbortError') toastr.error("Не удалось поделиться") })
        } else {
            navigator.clipboard.writeText(url)
                .then(() => toastr.success("Ссылка скопирована в буфер обмена"))
                .catch(() => toastr.error("Не удалось скопировать ссылку"))
        }
    }
}